export const PATH_MATCHER_PRIVATE = Symbol('path-matcher-private');
//# sourceMappingURL=privates.js.map